const normalizePartValue = (value) => {
  const normalized = value == null ? '' : String(value).trim();
  if (!normalized) return '';
  const lowered = normalized.toLowerCase();
  if (lowered === 'null' || lowered === 'undefined') return '';
  return normalized;
};

export const parseGroupArtistPartValues = (raw) => {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((entry) => normalizePartValue(entry)).filter(Boolean);
  }
  if (typeof raw === 'number' || typeof raw === 'bigint') {
    const normalized = normalizePartValue(raw);
    return normalized ? [normalized] : [];
  }
  if (typeof raw !== 'string') return [];
  const trimmed = raw.trim();
  if (!trimmed) return [];
  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) {
      return parsed.map((entry) => normalizePartValue(entry)).filter(Boolean);
    }
  } catch (_) {
    // fallback below
  }
  if (/^\{.*\}$/.test(trimmed)) {
    return trimmed
      .slice(1, -1)
      .split(',')
      .map((entry) => normalizePartValue(entry.replace(/^['"]|['"]$/g, '')))
      .filter(Boolean);
  }
  if (trimmed.includes(',')) {
    return trimmed
      .split(',')
      .map((entry) => normalizePartValue(entry))
      .filter(Boolean);
  }
  if (/^\d+(?:\s+\d+)+$/.test(trimmed)) {
    return trimmed
      .split(/\s+/)
      .map((entry) => normalizePartValue(entry))
      .filter(Boolean);
  }
  return [trimmed];
};

export const resolveGroupArtistPartValues = (artist) => {
  if (!artist || typeof artist !== 'object') return [];
  const sources = [
    artist.parts,
    artist.artist_parts,
    artist.part_ids,
    artist.partIds,
    artist.part_id,
    artist.partId,
    artist.main_part_id,
    artist.mainPartId,
    artist.part_value,
    artist.part,
    artist.mainPart,
    artist.main_part,
    artist.part_short_name,
    artist.partShortName,
    artist.main_part_short_name,
    artist.mainPartShortName,
    artist.partLabel,
    artist.part_label,
    artist.mainPartLabel,
    artist.main_part_label,
  ];
  for (const source of sources) {
    const values = parseGroupArtistPartValues(source);
    if (values.length > 0) {
      return values;
    }
  }
  return [];
};
